import * as React from 'react';
import { ENVIRONMENT_LABEL } from '../config';
import { PRODUCT_NAME } from './product';

/**
 * The logo: "docquet" in Fredoka, lower case, "doc" in purple and "quet" in ink (white on dark backgrounds).
 * Screen readers hear the name once.
 */
export function Wordmark(props: { size?: number; dark?: boolean }): React.ReactElement {
  return (
    <span className={props.dark ? 'wordmark on-dark' : 'wordmark'} style={{ fontSize: props.size ?? 22 }} aria-label={PRODUCT_NAME} role="img">
      <span className="wm-doc" aria-hidden="true">doc</span><span className="wm-quet" aria-hidden="true">quet</span>
    </span>
  );
}

/** "by [83] EightyThreeLabs", with the company's own logo and wordmark. */
export function By83(): React.ReactElement {
  return (
    <span className="by83">
      by
      <img src="/eightythreelabs-32.png" width={16} height={16} alt="" aria-hidden="true" style={{ borderRadius: 3 }} />
      <span className="e83"><b>EightyThree</b>Labs</span>
    </span>
  );
}

export function Brand(props: { subtitle?: React.ReactNode; size?: number }): React.ReactElement {
  return (
    <div className="brand">
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span className="brand-name"><Wordmark size={props.size} /> {ENVIRONMENT_LABEL && <span className="env-badge">{ENVIRONMENT_LABEL}</span>}</span>
        {props.subtitle && <span className="brand-sub">{props.subtitle}</span>}
      </div>
    </div>
  );
}

export function Footer(): React.ReactElement {
  return (
    <footer className="footer">
      <span>© {new Date().getFullYear()} EightyThreeLabs Inc.</span>
      <a href="/security">Security</a>
      <a href="/privacy">Privacy</a>
      <a href="/terms">Terms</a>
      <a href="/support">Help and support</a>
    </footer>
  );
}
